import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth14getGetScreenTruthRequirementsResponseSchema = jsonObject
export type tcpscreentruth14getGetScreenTruthRequirementsResponse = z.infer<typeof tcpscreentruth14getGetScreenTruthRequirementsResponseSchema>
export const tcpscreentruth14getGetScreenTruthVisitsIdResponseSchema = jsonObject
export type tcpscreentruth14getGetScreenTruthVisitsIdResponse = z.infer<typeof tcpscreentruth14getGetScreenTruthVisitsIdResponseSchema>
export const tcpscreentruth14getGetScreenTruthCoverageResponseSchema = jsonObject
export type tcpscreentruth14getGetScreenTruthCoverageResponse = z.infer<typeof tcpscreentruth14getGetScreenTruthCoverageResponseSchema>
export const tcpscreentruth14getGetScreenTruthStatusResponseSchema = jsonObject
export type tcpscreentruth14getGetScreenTruthStatusResponse = z.infer<typeof tcpscreentruth14getGetScreenTruthStatusResponseSchema>
export const tcpscreentruth14getGetScreenTruthDifferencesResponseSchema = jsonObject
export type tcpscreentruth14getGetScreenTruthDifferencesResponse = z.infer<typeof tcpscreentruth14getGetScreenTruthDifferencesResponseSchema>
